<template>
    <div class="print" ref="printContent">
        <table width="100%" border="1" align="center">
            <tr align="center">
                <td colspan="9"><strong style="font-size:25px">抽检确认单</strong></td>
            </tr>
            <!-- <tr>
                <td width="18%">协议供货单位：</td>
                <td colspan="6">武汉华源新盛电力有限公司变压器质检分公司</td>
                <td width="100px" rowspan="3">
                    <img width="100px" src="http://47.96.148.125:8081/Upload/qrcode.png"/>
                </td>
            </tr>
            <tr>
                <td width="18%">项目管理部门：</td>
                <td colspan="6">客户服务中心市场及大客户服务室</td>
            </tr>
            <tr>
                <td width="18%">供应商名称：</td>
                <td colspan="6">{{ user.fullUnitName }}</td>
            </tr> -->
            <tr>
                <td width="18%">供应商名称：</td>
                <td colspan="6">{{ user.fullUnitName }}</td>
                <td width="100px">
                    <img width="100px" :src="qrstr" />
                </td>
            </tr>
            <tr align="center">
                <td colspan="8">中标设备、材料名称规格数量</td>
            </tr>
            <tr>
                <td>工程名称</td>
                <td>报装编号</td>
                <td>物料名称</td>
                <td>型号规格</td>
                <td>数量</td>
                <td>单位</td>
                <td>联系人</td>
                <td>地点</td>
            </tr>
            <tr v-for="item in printObj" :key="item.b_id">
                <td>{{ item.a_projectName }}</td>
                <td>{{ item.a_bzNo }}</td>
                <td>{{ item.a_materialName }}</td>
                <td>{{ item.a_model }}</td>
                <td>{{ item.b_num || 0 }}</td>
                <td>{{ item.a_unit }}</td>
                <td>{{ item.b_linkman }}<br />{{ item.b_linkphone }}</td>
                <td>{{ item.b_address }}</td>
            </tr>
        </table>
    </div>
</template>
<script>
import { getUserInfo } from "@/plugins/common";
export default {
    props: ["printObj"],
    data() {
        return {
            user: {},
            qrstr: ""
        }
    },
    mounted: function () {
        this.user = getUserInfo();
        this.setData();
    },
    watch: {
        printObj: {
            handler(newValue, oldValue) {
                this.printObj = newValue;

                this.setData();
            },
            deep: true,
        }
    },
    methods: {
        print() {
            this.$print(this.$refs.printContent);
        },
        setData() {
            // console.log(this.printObj);
            let content = { fun: this.user.fullUnitName, item: [] };
            this.printObj.forEach((item) => {
                content.item.push(item.b_id);
                // console.log(item);
            });

            let url = "https://devlist.top/#/project/qr?c=" + encodeURIComponent(JSON.stringify(content));
            this.qrstr = "https://api.qrserver.com/v1/create-qr-code/?data=" + encodeURIComponent(url);
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/style.scss";
@import "./detail.scss";
@import "./templateDetail.scss";

.printHtml {
    min-width: auto;

    body {
        min-width: auto;
        width: 100%;
    }
}
</style>
